import { useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';

export function PainterCreatePage(): ReactNode {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [territoryId, setTerritoryId] = useState('');
  const [workTypesCsv, setWorkTypesCsv] = useState('');
  const [aadhaarDocId, setAadhaarDocId] = useState('');
  const [idCardDocId, setIdCardDocId] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (!displayName) { setError('Display name required'); return; }
    if (!/^[6-9][0-9]{9}$/.test(mobileNumber)) { setError('Mobile must be 10 digits starting 6-9'); return; }
    if (!territoryId) { setError('Territory required'); return; }
    const workTypes = workTypesCsv.split(',').map((s) => s.trim()).filter(Boolean);
    if (workTypes.length === 0) { setError('At least one work type'); return; }
    if (!aadhaarDocId || !idCardDocId) { setError('Both KYC docs required (Aadhaar + ID card)'); return; }
    setError(null); setBusy(true);
    try {
      const res = await apiRequest<{ painterUserId: string }>('/v1/vendor/painters', {
        method: 'POST', token,
        body: {
          displayName, mobileNumber, territoryId, workTypes,
          kycDocuments: [
            { kind: 'AADHAAR', dmsDocId: aadhaarDocId },
            { kind: 'ID_CARD', dmsDocId: idCardDocId },
          ],
        },
      });
      navigate(`/vendor/portal/painters?onboarded=${res.painterUserId}`);
    } catch (e) { setError((e as Error).message); } finally { setBusy(false); }
  }

  return (
    <main aria-label="painter-new">
      <h1>Onboard painter</h1>
      {error ? <p role="alert">{error}</p> : null}

      <label htmlFor="dn">Display name</label>
      <input id="dn" aria-label="display-name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />

      <label htmlFor="mb">Mobile</label>
      <input id="mb" aria-label="mobile" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />

      <label htmlFor="terr">Territory</label>
      <input id="terr" aria-label="territory" value={territoryId} onChange={(e) => setTerritoryId(e.target.value)} />

      <label htmlFor="wt">Work types (csv)</label>
      <input id="wt" aria-label="work-types" value={workTypesCsv} onChange={(e) => setWorkTypesCsv(e.target.value)} />

      <fieldset aria-label="kyc-docs">
        <legend>KYC documents</legend>
        <label htmlFor="adh">Aadhaar DMS id</label>
        <input id="adh" aria-label="aadhaar-doc-id" value={aadhaarDocId} onChange={(e) => setAadhaarDocId(e.target.value)} />
        <label htmlFor="idc">ID card DMS id</label>
        <input id="idc" aria-label="id-card-doc-id" value={idCardDocId} onChange={(e) => setIdCardDocId(e.target.value)} />
      </fieldset>

      <button onClick={submit} disabled={busy} aria-label="create-painter">{busy ? 'Saving…' : 'Onboard'}</button>
    </main>
  );
}
